import React from 'react';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import Button from '../../../atoms/Button/Button';

type LoadErrorViewProps = {
  backLabel: string;
  onBack: () => void;
  title: string;
};

/**
 * Pantalla de una vista que no ha podido cargar. Se pinta sin layout, así que hace de landmark principal.
 * No es `role="alert"`: quien la usa ya avisa con un toast, que se anuncia por su región `status`.
 */
function LoadErrorView({ backLabel, onBack, title }: LoadErrorViewProps): JSX.Element {
  return (
    <main className="load-error-view" id={MAIN_CONTENT_ID} tabIndex={-1}>
      <h1 className="load-error-view__title">{title}</h1>
      <Button onClick={onBack} text={backLabel} variant="primary" />
    </main>
  );
}

export default LoadErrorView;
